import React from "react";
import backIcon from "../../assets/images/back-btn-arrow.svg";
import backArrowLeftIcon from "../../assets/images/back-left-arrow.svg";

function PageBackBtn(props: any) {
  const { onClick, iconOnly = false, width, text = true } = props;
  return (
    <>
      {!iconOnly ? (
        <button
          style={{
            border: "none",
            background: "#fff",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            fontSize: "14px",
            fontWeight: "500",
            color: "#667085",
            lineHeight: "20px",
            gap: "8px",
          }}
          onClick={onClick}
        >
          <img src={backIcon} alt="back" />
          {text && <div>Back</div>}
        </button>
      ) : (
        <button
          style={{
            border: "1px solid #BFBFBF",
            background: "#fff",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            width: width ? width : "34px",
            height: width ? `${parseInt(width) + 2}px` : "36px",
            alignItems: "center",
            borderRadius: "4PX",
          }}
          onClick={onClick}
        >
          <img src={backArrowLeftIcon} alt="back" />
        </button>
      )}
    </>
  );
}

export default PageBackBtn;
